import { useEffect, useMemo, useState } from 'react';
import { StyleSheet } from 'react-native';
import { Dropdown } from 'react-native-element-dropdown';
import { colorList } from 'utils/colors';
import { ThemedValues, ThemedFonts, ThemedShared } from 'styles/themed'

const Select = ({ value, data, search = false, onSelect, selectedIndex, selected }) => {

    const [ isFocus, setIsFocus ] = useState(false);
    const [ updatedValue, setUpdatedValue ] = useState( value || null );

    const isSearch = useMemo( () => {
        return search || data?.length > 20;
    }, [search, data?.length]);

    useEffect(() => {
        if (value) {
			setUpdatedValue(value);
		}
    }, [value]);

    const onChange = ( item ) => {
        setUpdatedValue( item.value );
        setIsFocus(false);

        if (onSelect) {
            onSelect( item.value );
        }
    }

    return (
        <Dropdown
            style={[ 
                styles.dropdown, 
                isFocus && styles.dropdownBorderColorLight
            ]}
            placeholderStyle={ styles.placeholder }
            selectedTextStyle={ styles.selectedText }
            inputSearchStyle={ styles.inputSearch }
            itemTextStyle={ styles.itemText }
            iconStyle={ styles.iconStyle }
            activeColor={ colorList.PRIMARY.light }
            fontFamily={ ThemedFonts.regular.fontFamily }
            fontSize={ 14 }
            data={ data }
            search={ isSearch }
            value={ updatedValue }
            maxHeight={ 300} 
            labelField="label"
            valueField="value"
            placeholder={ !isFocus ? 'Select item' : '...' }
            searchPlaceholder="Search..."
            onFocus={ setIsFocus.bind( this, true ) }
            onBlur={ setIsFocus.bind( this, false ) }
            onChange={ onChange }
        />
    )
}

const styles = StyleSheet.create({
	dropdownBorderColorLight: {
		borderColor: colorList.PRIMARY.light,
	},
    container: {
        backgroundColor: 'white',
        padding: ThemedShared.paddingSmall.padding,
    },
    dropdown: {
        backgroundColor: colorList.WHITE.primary,
        height: 40,
        borderColor: colorList.GREY.light,
        borderWidth: 0.5,
        borderRadius: ThemedValues.borderRadius,
        paddingHorizontal: 8,
    },
    icon: {
        marginRight: 5,
    },

    label: {
        ...ThemedFonts.regular,
        fontSize: 14,

        position: 'absolute',
        backgroundColor: 'white',
        left: 22,
        top: 8,
        zIndex: 999,
        paddingHorizontal: 8,
    },
    itemText: {
        ...ThemedFonts.regular,
        fontSize: 14,
    },
    placeholder: {
        ...ThemedFonts.regular,
        fontSize: 14,
    },
    selectedText: {
        ...ThemedFonts.regular,
        fontSize: 14,
    },
    inputSearch: {
        ...ThemedFonts.regular,
        height: 40,
        fontSize: 14,
    },

    iconStyle: {
        width: 20,
        height: 20,
    },
});

export default Select;
